module.exports = __webpack_public_path__ + "img/ic_wuxing.f49ed6af.png";